import { Option } from "@/types/option";

export type LookupOptionSource = {
  lookupId?: string | number | null;
  LookupId?: string | number | null;
  id?: string | number | null;
  Id?: string | number | null;
  code?: string | null;
  Code?: string | null;
  nameEN?: string | null;
  NameEN?: string | null;
  name?: string | null;
  Name?: string | null;
  isDraft?: boolean;
  IsDraft?: boolean;
};

export function lookupEntryIsDraft(entry: LookupOptionSource): boolean {
  return Boolean(entry.isDraft ?? entry.IsDraft);
}

export function mapLookupsToOptions(lookupItems: LookupOptionSource[]): Option[] {
  return (lookupItems || []).map((t) => ({
    value: String(
      t.lookupId ?? t.LookupId ?? t.id ?? t.Id ?? t.code ?? t.Code ?? ""
    ),
    label: t.nameEN || t.NameEN || t.name || t.Name || "",
    isDraft: lookupEntryIsDraft(t),
  }));
}

/** Dropdown options: non-drafted only, plus the current selection in edit/view when it is drafted. */
export function filterLookupDropdownOptions(
  options: Option[],
  selectedId?: string | number | null,
  includeSelectedDraft = false
): Option[] {
  const selected =
    selectedId !== undefined && selectedId !== null && String(selectedId) !== ""
      ? String(selectedId)
      : null;

  return options.filter((opt) => {
    const isSelected = selected && String(opt.value) === selected;
    if (opt.isDraft && !(includeSelectedDraft && isSelected)) return false;
    return true;
  });
}

export function isOtherLookupLabel(
  label: string | null | undefined,
  pattern: RegExp
): boolean {
  return pattern.test(String(label || "").trim());
}

/** Preview label: show the selected lookup (including drafts); "Other" uses custom text only. */
export function resolveSelectedLookupPreviewLabel(
  options: Option[],
  selectedId?: string | number | null,
  config?: {
    customValue?: string;
    isOtherSelected?: boolean;
    otherLabelPattern?: RegExp;
  }
): string {
  if (
    selectedId === undefined ||
    selectedId === null ||
    String(selectedId).trim() === ""
  ) {
    return "";
  }

  if (config?.isOtherSelected) {
    return config.customValue?.trim() || "";
  }

  const selected = options.find(
    (opt) => String(opt.value) === String(selectedId)
  );
  if (!selected) return "";

  if (
    config?.otherLabelPattern &&
    isOtherLookupLabel(selected.label, config.otherLabelPattern)
  ) {
    return config.customValue?.trim() || "";
  }

  return String(selected.label || "").trim();
}
